"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _resultClass = _interopRequireDefault(require("./resultClass"));

var _message = _interopRequireDefault(require("./message"));

var _crypto = _interopRequireDefault(require("./crypto"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var base64Charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz/+";
var paddingChar = " ";
var indexModulo = 16;
var passArray = ["aoLJH8mSpjshqvgE3ByJlsZrrLBZPn9jaT7CLlkLI/c=", "l2M9wEr3yXEE3CLQrRJvxCdFvHDOwT7I69k8omGFlSk=", "mMzgAfaGzGfXwx2TUFqzT7r9IWcnacY8DXwAdyeKjkA=", "9Gob4CDjqVAFi1t62fwEZMGJdY0VQooR3gLzYWLhOME="];
var saltArray = ["c59gLVb5NxTMX5kr7iTOqw==", "KCsO9Kq3xz3tbdUkr8ds1w==", "NK7Ul1cSgBcrWZBajDrQ+w==", "TOeEL3oZsIYIIhBiwGYxUQ==", "T18JuzXd+PMa8fcXbP2pmQ==", "xkBBUNqxSTU5kwjBgcy2vA==", "rQzHVvSOd6Xg1WmR4W0G8A==", "ZaY5qVBfzqHCnNdLyNYR4Q==", "xfo91euMrComvS8Rs+Lvhw==", "aGSgfPWEfF0Km42a634igw==", "VGthy4FU6QlFkWcSzeUuGw==", "09F8l9IWZmZiunozDQkKtg==", "N7eIumJ3WRSIEM8grsnymQ==", "KbTKXrtraxT6fTJTDRJZeQ==", "q5PxAhW2nF6BB0bSgq/ewQ==", "vByYK6mh2ZctFH2qBUXBeQ=="];
var magicArray = ["0z0z0z0z", "1x1x1x1x", "2y2y2y2y", "3w3w3w3w", "4v4v4v4v", "5u5u5u5u", "6t6t6t6t", "7s7s7s7s", "8r8r8r8r", "9q9q9q9q", "ApApApAp", "BoBoBoBo", "CnCnCnCn", "DmDmDmDm", "ElElElEl", "FkFkFkFk"];

var Envelope = /*#__PURE__*/function () {
  function Envelope() {
    _classCallCheck(this, Envelope);
  }

  _createClass(Envelope, null, [{
    key: "insert",
    //  Inserimento di una stringa nella busta crittografata
    //  ----------------------------------------------------
    value: function insert(data) {
      var key = Math.floor(Math.random() * base64Charset.length);
      var magic = Math.floor(Math.random() * base64Charset.length);

      var result = _crypto.default.encrypt(this.preparePattern(magic) + data, passArray[Math.trunc(key / indexModulo)], saltArray[key % indexModulo]);

      if (result.code !== _message.default.IS_OK) return result;
      return new _resultClass.default(_message.default.OK, "", base64Charset[key] + base64Charset[magic] + result.data);
    } //  Inserimento di una stringa nella busta crittografata senza numero magico
    //  ------------------------------------------------------------------------

  }, {
    key: "simpleInsert",
    value: function simpleInsert(data) {
      var key = Math.floor(Math.random() * base64Charset.length);
      var magic = Math.floor(Math.random() * base64Charset.length); // E' solo un padding per il secondo carattere della chiave

      var result = _crypto.default.encrypt(data, passArray[Math.trunc(key / indexModulo)], saltArray[key % indexModulo]);

      if (result.code !== _message.default.IS_OK) return result;
      return new _resultClass.default(_message.default.OK, "", base64Charset[key] + base64Charset[magic] + result.data);
    } //  Estrazione di una stringa dalla busta crittografata
    //  ---------------------------------------------------

  }, {
    key: "extract",
    value: function extract(envelope) {
      var key = base64Charset.indexOf(envelope.substring(0, 1));
      var magic = base64Charset.indexOf(envelope.substring(1, 2));

      var result = _crypto.default.decrypt(envelope.substring(2), passArray[Math.trunc(key / indexModulo)], saltArray[key % indexModulo]);

      if (result.code !== _message.default.IS_OK) return result;
      var pattern = this.preparePattern(magic);
      if (result.data.substring(0, pattern.length) !== pattern) return new _resultClass.default(_message.default.ERR_INVALID_TOKEN);
      return new _resultClass.default(_message.default.OK, "", result.data.substring(pattern.length));
    } //  Estrazione di una stringa dalla busta crittografata senza numero magico
    //  -----------------------------------------------------------------------

  }, {
    key: "simpleExtract",
    value: function simpleExtract(envelope) {
      var key = base64Charset.indexOf(envelope.substring(0, 1));

      var result = _crypto.default.decrypt(envelope.substring(2), passArray[Math.trunc(key / indexModulo)], saltArray[key % indexModulo]);

      if (result.code !== _message.default.IS_OK) return result;
      return new _resultClass.default(_message.default.OK, "", result.data);
    } //  Preparazione del pattern per la magic sequence
    //  ----------------------------------------------

  }, {
    key: "preparePattern",
    value: function preparePattern(magic) {
      var sequence = magicArray[magic % indexModulo];
      return sequence.padStart(Math.trunc(magic / indexModulo) + sequence.length, paddingChar).padEnd(base64Charset.length / indexModulo + sequence.length, paddingChar);
    }
  }]);

  return Envelope;
}();

var _default = Envelope;
exports.default = _default;